import script from "./KalibratieoproepPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./KalibratieoproepPage.vue?vue&type=script&setup=true&lang=ts"

import "./KalibratieoproepPage.vue?vue&type=style&index=0&id=86386344&lang=css"

const __exports__ = script;

export default __exports__